import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdGenerativeAiOptOutCacheKeys: AllRouteEndpoints[] = [];
